"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../models");
var ety = require("../../enumeration-type/index");
var Aggregation = /** @class */ (function () {
    function Aggregation() {
    }
    return Aggregation;
}());
exports.Aggregation = Aggregation;
var AllocationTerm = /** @class */ (function () {
    function AllocationTerm() {
    }
    return AllocationTerm;
}());
exports.AllocationTerm = AllocationTerm;
var AssignableProduct = /** @class */ (function () {
    function AssignableProduct() {
    }
    return AssignableProduct;
}());
exports.AssignableProduct = AssignableProduct;
var BoolResponse = /** @class */ (function () {
    function BoolResponse() {
    }
    return BoolResponse;
}());
exports.BoolResponse = BoolResponse;
var DateRangeRule = /** @class */ (function () {
    function DateRangeRule() {
    }
    return DateRangeRule;
}());
exports.DateRangeRule = DateRangeRule;
var DateRangeRuleInstance = /** @class */ (function (_super) {
    __extends(DateRangeRuleInstance, _super);
    function DateRangeRuleInstance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DateRangeRuleInstance;
}(DateRangeRule));
exports.DateRangeRuleInstance = DateRangeRuleInstance;
var Outcome = /** @class */ (function () {
    function Outcome() {
    }
    return Outcome;
}());
exports.Outcome = Outcome;
var AssetOutcome = /** @class */ (function (_super) {
    __extends(AssetOutcome, _super);
    function AssetOutcome() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AssetOutcome;
}(Outcome));
exports.AssetOutcome = AssetOutcome;
var TagOutcome = /** @class */ (function (_super) {
    __extends(TagOutcome, _super);
    function TagOutcome() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TagOutcome;
}(Outcome));
exports.TagOutcome = TagOutcome;
var TextOutcome = /** @class */ (function (_super) {
    __extends(TextOutcome, _super);
    function TextOutcome() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TextOutcome;
}(Outcome));
exports.TextOutcome = TextOutcome;
var DeliverableOutcome = /** @class */ (function (_super) {
    __extends(DeliverableOutcome, _super);
    function DeliverableOutcome() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableOutcome;
}(Outcome));
exports.DeliverableOutcome = DeliverableOutcome;
var DependentDeliverable = /** @class */ (function () {
    function DependentDeliverable() {
    }
    return DependentDeliverable;
}());
exports.DependentDeliverable = DependentDeliverable;
var DependerDeliverables = /** @class */ (function () {
    function DependerDeliverables() {
    }
    return DependerDeliverables;
}());
exports.DependerDeliverables = DependerDeliverables;
var DeliverableActions = /** @class */ (function () {
    function DeliverableActions() {
    }
    return DeliverableActions;
}());
exports.DeliverableActions = DeliverableActions;
var DeliverableUnits = /** @class */ (function () {
    function DeliverableUnits() {
    }
    return DeliverableUnits;
}());
exports.DeliverableUnits = DeliverableUnits;
var UnitPace = /** @class */ (function () {
    function UnitPace() {
    }
    return UnitPace;
}());
exports.UnitPace = UnitPace;
var FeedDetails = /** @class */ (function () {
    function FeedDetails() {
    }
    return FeedDetails;
}());
exports.FeedDetails = FeedDetails;
var Owner = /** @class */ (function () {
    function Owner() {
    }
    Owner.prototype.IsWithinTeam = function (teamId) {
        if (this.id == teamId)
            return true;
        if (this.team === null)
            return false;
        return this.team.IsWithinTeam(teamId);
    };
    return Owner;
}());
exports.Owner = Owner;
var DateOwner = /** @class */ (function () {
    function DateOwner() {
    }
    return DateOwner;
}());
exports.DateOwner = DateOwner;
var AvailabilityAggregateListPerMonth = /** @class */ (function () {
    function AvailabilityAggregateListPerMonth() {
    }
    return AvailabilityAggregateListPerMonth;
}());
exports.AvailabilityAggregateListPerMonth = AvailabilityAggregateListPerMonth;
var AvailabilityAggregate = /** @class */ (function () {
    function AvailabilityAggregate() {
    }
    return AvailabilityAggregate;
}());
exports.AvailabilityAggregate = AvailabilityAggregate;
var ProfileAvailability = /** @class */ (function () {
    function ProfileAvailability() {
    }
    return ProfileAvailability;
}());
exports.ProfileAvailability = ProfileAvailability;
var ProfileAvailabilityPerDay = /** @class */ (function (_super) {
    __extends(ProfileAvailabilityPerDay, _super);
    function ProfileAvailabilityPerDay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProfileAvailabilityPerDay;
}(ProfileAvailability));
exports.ProfileAvailabilityPerDay = ProfileAvailabilityPerDay;
var ProfileAvailablityPerDayWithWork = /** @class */ (function (_super) {
    __extends(ProfileAvailablityPerDayWithWork, _super);
    function ProfileAvailablityPerDayWithWork() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProfileAvailablityPerDayWithWork;
}(ProfileAvailability));
exports.ProfileAvailablityPerDayWithWork = ProfileAvailablityPerDayWithWork;
var ProfileAvailabilityPerMonth = /** @class */ (function (_super) {
    __extends(ProfileAvailabilityPerMonth, _super);
    function ProfileAvailabilityPerMonth() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProfileAvailabilityPerMonth;
}(ProfileAvailability));
exports.ProfileAvailabilityPerMonth = ProfileAvailabilityPerMonth;
var ProfileAvailabilityPerDayInPeriod = /** @class */ (function (_super) {
    __extends(ProfileAvailabilityPerDayInPeriod, _super);
    function ProfileAvailabilityPerDayInPeriod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProfileAvailabilityPerDayInPeriod;
}(ProfileAvailabilityPerDay));
exports.ProfileAvailabilityPerDayInPeriod = ProfileAvailabilityPerDayInPeriod;
var DependentPhase = /** @class */ (function () {
    function DependentPhase() {
    }
    return DependentPhase;
}());
exports.DependentPhase = DependentPhase;
var DependerPhases = /** @class */ (function () {
    function DependerPhases() {
    }
    return DependerPhases;
}());
exports.DependerPhases = DependerPhases;
var PhaseActions = /** @class */ (function () {
    function PhaseActions() {
    }
    return PhaseActions;
}());
exports.PhaseActions = PhaseActions;
var PointInTime = /** @class */ (function () {
    function PointInTime() {
    }
    return PointInTime;
}());
exports.PointInTime = PointInTime;
var ProductDefinition = /** @class */ (function (_super) {
    __extends(ProductDefinition, _super);
    function ProductDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProductDefinition;
}(AssignableProduct));
exports.ProductDefinition = ProductDefinition;
var TagAndClassInstance = /** @class */ (function () {
    function TagAndClassInstance() {
    }
    return TagAndClassInstance;
}());
exports.TagAndClassInstance = TagAndClassInstance;
var TagInstance = /** @class */ (function () {
    function TagInstance() {
    }
    return TagInstance;
}());
exports.TagInstance = TagInstance;
var ProductDefinitionInstance = /** @class */ (function () {
    function ProductDefinitionInstance() {
    }
    return ProductDefinitionInstance;
}());
exports.ProductDefinitionInstance = ProductDefinitionInstance;
var ProductDefinitionPhase = /** @class */ (function () {
    function ProductDefinitionPhase() {
    }
    return ProductDefinitionPhase;
}());
exports.ProductDefinitionPhase = ProductDefinitionPhase;
var ProductPhaseInstance = /** @class */ (function () {
    function ProductPhaseInstance() {
    }
    return ProductPhaseInstance;
}());
exports.ProductPhaseInstance = ProductPhaseInstance;
var Term = /** @class */ (function () {
    function Term() {
    }
    return Term;
}());
exports.Term = Term;
var TimeUse = /** @class */ (function () {
    function TimeUse() {
    }
    return TimeUse;
}());
exports.TimeUse = TimeUse;
var UnitRangeRule = /** @class */ (function () {
    function UnitRangeRule() {
    }
    return UnitRangeRule;
}());
exports.UnitRangeRule = UnitRangeRule;
var UnitRangeRuleInstance = /** @class */ (function (_super) {
    __extends(UnitRangeRuleInstance, _super);
    function UnitRangeRuleInstance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnitRangeRuleInstance;
}(UnitRangeRule));
exports.UnitRangeRuleInstance = UnitRangeRuleInstance;
var Units = /** @class */ (function () {
    function Units() {
    }
    return Units;
}());
exports.Units = Units;
var UnitsDateSlice = /** @class */ (function () {
    function UnitsDateSlice() {
    }
    return UnitsDateSlice;
}());
exports.UnitsDateSlice = UnitsDateSlice;
var UnitSpread = /** @class */ (function () {
    function UnitSpread() {
    }
    return UnitSpread;
}());
exports.UnitSpread = UnitSpread;
var VideoUnCreatedWork = /** @class */ (function () {
    function VideoUnCreatedWork() {
    }
    return VideoUnCreatedWork;
}());
exports.VideoUnCreatedWork = VideoUnCreatedWork;
var WorkType = /** @class */ (function (_super) {
    __extends(WorkType, _super);
    function WorkType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WorkType;
}(AssignableProduct));
exports.WorkType = WorkType;
var IDeliverablePagedList = /** @class */ (function (_super) {
    __extends(IDeliverablePagedList, _super);
    function IDeliverablePagedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IDeliverablePagedList;
}(models_1.IPagedList));
exports.IDeliverablePagedList = IDeliverablePagedList;
var IDeliverableAggregatePagedList = /** @class */ (function (_super) {
    __extends(IDeliverableAggregatePagedList, _super);
    function IDeliverableAggregatePagedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return IDeliverableAggregatePagedList;
}(models_1.IPagedList));
exports.IDeliverableAggregatePagedList = IDeliverableAggregatePagedList;
var DeliverableTotalledPagedList = /** @class */ (function (_super) {
    __extends(DeliverableTotalledPagedList, _super);
    function DeliverableTotalledPagedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DeliverableTotalledPagedList;
}(models_1.IPagedList));
exports.DeliverableTotalledPagedList = DeliverableTotalledPagedList;
//export class DeliverableMessage {
//  public id: string;
//  public date: Date;
//  public feed: FeedDetails;
//  public deliverable: stub.DeliverableStub;
//  public deliverableHead?: stub.DeliverableHeadStub;
//  public product?: stub.ProductDefinitionInstanceStub;
//  public comment?: string;
//  public operator?: Owner;
//  public allocatee?: Owner;
//  public action?: BaseAction;
//}
// Adjust Roles Models Start
var RoleAssignment = /** @class */ (function () {
    function RoleAssignment() {
    }
    return RoleAssignment;
}());
exports.RoleAssignment = RoleAssignment;
var AdjustRoleHintRequest = /** @class */ (function () {
    function AdjustRoleHintRequest() {
    }
    return AdjustRoleHintRequest;
}());
exports.AdjustRoleHintRequest = AdjustRoleHintRequest;
// Adjust Roles Models End
var ActionDataAdjustWorkSlot = /** @class */ (function () {
    function ActionDataAdjustWorkSlot() {
    }
    return ActionDataAdjustWorkSlot;
}());
exports.ActionDataAdjustWorkSlot = ActionDataAdjustWorkSlot;
var ActionDataAllocate = /** @class */ (function () {
    function ActionDataAllocate() {
    }
    return ActionDataAllocate;
}());
exports.ActionDataAllocate = ActionDataAllocate;
var ActionDataContract = /** @class */ (function () {
    function ActionDataContract() {
    }
    return ActionDataContract;
}());
exports.ActionDataContract = ActionDataContract;
var ActionDataCreateDeliverable = /** @class */ (function () {
    function ActionDataCreateDeliverable() {
    }
    return ActionDataCreateDeliverable;
}());
exports.ActionDataCreateDeliverable = ActionDataCreateDeliverable;
var ActionDataDeliverable = /** @class */ (function () {
    function ActionDataDeliverable() {
    }
    return ActionDataDeliverable;
}());
exports.ActionDataDeliverable = ActionDataDeliverable;
var ActionDataStartDeliverable = /** @class */ (function () {
    function ActionDataStartDeliverable() {
    }
    return ActionDataStartDeliverable;
}());
exports.ActionDataStartDeliverable = ActionDataStartDeliverable;
var ActionDataCompleteDeliverable = /** @class */ (function () {
    function ActionDataCompleteDeliverable() {
    }
    return ActionDataCompleteDeliverable;
}());
exports.ActionDataCompleteDeliverable = ActionDataCompleteDeliverable;
var ActionDataDeliverableDeliverable = /** @class */ (function () {
    function ActionDataDeliverableDeliverable() {
    }
    return ActionDataDeliverableDeliverable;
}());
exports.ActionDataDeliverableDeliverable = ActionDataDeliverableDeliverable;
var ActionDataParent = /** @class */ (function () {
    function ActionDataParent() {
    }
    return ActionDataParent;
}());
exports.ActionDataParent = ActionDataParent;
var ActionDataView = /** @class */ (function () {
    function ActionDataView() {
    }
    return ActionDataView;
}());
exports.ActionDataView = ActionDataView;
var ActionDataLock = /** @class */ (function () {
    function ActionDataLock() {
    }
    return ActionDataLock;
}());
exports.ActionDataLock = ActionDataLock;
var ActionDataUpdateDeliverable = /** @class */ (function () {
    function ActionDataUpdateDeliverable() {
    }
    return ActionDataUpdateDeliverable;
}());
exports.ActionDataUpdateDeliverable = ActionDataUpdateDeliverable;
var ActionDataWithTermMaxUnits = /** @class */ (function () {
    function ActionDataWithTermMaxUnits() {
    }
    return ActionDataWithTermMaxUnits;
}());
exports.ActionDataWithTermMaxUnits = ActionDataWithTermMaxUnits;
var ActionDataCreateNewPhase = /** @class */ (function () {
    function ActionDataCreateNewPhase() {
    }
    return ActionDataCreateNewPhase;
}());
exports.ActionDataCreateNewPhase = ActionDataCreateNewPhase;
var ActionDataSwitchProduct = /** @class */ (function () {
    function ActionDataSwitchProduct() {
    }
    return ActionDataSwitchProduct;
}());
exports.ActionDataSwitchProduct = ActionDataSwitchProduct;
var ActionDataAdjustHeadRoles = /** @class */ (function () {
    function ActionDataAdjustHeadRoles() {
    }
    return ActionDataAdjustHeadRoles;
}());
exports.ActionDataAdjustHeadRoles = ActionDataAdjustHeadRoles;
var ActionDataAdjustLineRoles = /** @class */ (function () {
    function ActionDataAdjustLineRoles() {
    }
    return ActionDataAdjustLineRoles;
}());
exports.ActionDataAdjustLineRoles = ActionDataAdjustLineRoles;
var ScheduleOptions = /** @class */ (function () {
    function ScheduleOptions() {
        this.staggerDates = true;
    }
    return ScheduleOptions;
}());
exports.ScheduleOptions = ScheduleOptions;
var MonthlyUnitsAggregate = /** @class */ (function () {
    function MonthlyUnitsAggregate() {
    }
    return MonthlyUnitsAggregate;
}());
exports.MonthlyUnitsAggregate = MonthlyUnitsAggregate;
var SalesforceAccount = /** @class */ (function () {
    function SalesforceAccount() {
    }
    return SalesforceAccount;
}());
exports.SalesforceAccount = SalesforceAccount;
var SalesforceAsset = /** @class */ (function () {
    function SalesforceAsset() {
    }
    return SalesforceAsset;
}());
exports.SalesforceAsset = SalesforceAsset;
var Action = /** @class */ (function () {
    function Action(name, id, module, priority, data) {
        this.name = name;
        this.id = id;
        this.module = module;
        this.priority = priority;
        this.data = data;
    }
    return Action;
}());
exports.Action = Action;
var AggregateUnitFieldSet = /** @class */ (function () {
    function AggregateUnitFieldSet() {
    }
    return AggregateUnitFieldSet;
}());
exports.AggregateUnitFieldSet = AggregateUnitFieldSet;
var AggregateRangeUnitFieldSet = /** @class */ (function (_super) {
    __extends(AggregateRangeUnitFieldSet, _super);
    function AggregateRangeUnitFieldSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AggregateRangeUnitFieldSet;
}(AggregateUnitFieldSet));
exports.AggregateRangeUnitFieldSet = AggregateRangeUnitFieldSet;
var AggregateCountFieldSet = /** @class */ (function () {
    function AggregateCountFieldSet() {
    }
    return AggregateCountFieldSet;
}());
exports.AggregateCountFieldSet = AggregateCountFieldSet;
var UnitsAggregateBase = /** @class */ (function () {
    function UnitsAggregateBase() {
    }
    return UnitsAggregateBase;
}());
exports.UnitsAggregateBase = UnitsAggregateBase;
var UnitsAggregateStatus = /** @class */ (function (_super) {
    __extends(UnitsAggregateStatus, _super);
    function UnitsAggregateStatus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnitsAggregateStatus;
}(UnitsAggregateBase));
exports.UnitsAggregateStatus = UnitsAggregateStatus;
var UnitsAggregateStatusUnits = /** @class */ (function (_super) {
    __extends(UnitsAggregateStatusUnits, _super);
    function UnitsAggregateStatusUnits() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnitsAggregateStatusUnits;
}(UnitsAggregateBase));
exports.UnitsAggregateStatusUnits = UnitsAggregateStatusUnits;
var UnitsAggregateStatusUnitsGroupedBy = /** @class */ (function (_super) {
    __extends(UnitsAggregateStatusUnitsGroupedBy, _super);
    function UnitsAggregateStatusUnitsGroupedBy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return UnitsAggregateStatusUnitsGroupedBy;
}(UnitsAggregateStatusUnits));
exports.UnitsAggregateStatusUnitsGroupedBy = UnitsAggregateStatusUnitsGroupedBy;
var BulkActionResponse = /** @class */ (function () {
    function BulkActionResponse() {
    }
    return BulkActionResponse;
}());
exports.BulkActionResponse = BulkActionResponse;
var BaseAction = /** @class */ (function (_super) {
    __extends(BaseAction, _super);
    function BaseAction(name, id, module, priority, data) {
        return _super.call(this, name, id, module, priority, data) || this;
    }
    BaseAction.GetAll = function () {
        return [this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.Delete, this.AddPhase, this.Lock, this.Update,
            this.UnStart, this.UnComplete, this.CreateFull, this.CreatePartial, this.Start, this.Complete, this.CreateMulti];
    };
    BaseAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    BaseAction.AdjustDates = new BaseAction("Adjust Dates", "AdjustDates", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.AdjustUnits = new BaseAction("Adjust Units", "AdjustUnits", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.Allocate = new BaseAction("Allocate", "Allocate", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.ViewProject = new BaseAction("View Deliverable Product", "ViewDeliverableProduct", ety.DeliverableModule.Base, ety.ActionPriority.Primary);
    BaseAction.ViewWork = new BaseAction("View Deliverable Work", "ViewDeliverableWork", ety.DeliverableModule.Base, ety.ActionPriority.Primary);
    BaseAction.Delete = new BaseAction("Delete", "Delete", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.AddPhase = new BaseAction("Add Phase", "AddPhase", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.Lock = new BaseAction("Lock", "Lock", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.Update = new BaseAction("Update", "Update", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.UnStart = new BaseAction("Un-Start", "UnStart", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.UnComplete = new BaseAction("Un-Complete", "UnComplete", ety.DeliverableModule.Base, ety.ActionPriority.Secondary);
    BaseAction.CreateFull = new BaseAction("Create Full", "CreateFull", ety.DeliverableModule.Base, ety.ActionPriority.Primary);
    BaseAction.CreatePartial = new BaseAction("Create Partial", "CreatePartial", ety.DeliverableModule.Base, ety.ActionPriority.Primary);
    BaseAction.CreateMulti = new BaseAction("Create Multi", "CreateMulti", ety.DeliverableModule.Base, ety.ActionPriority.Primary);
    BaseAction.Start = new BaseAction("Start", "Start", ety.DeliverableModule.Base, ety.ActionPriority.Primary);
    BaseAction.Complete = new BaseAction("Complete", "Complete", ety.DeliverableModule.Base, ety.ActionPriority.Primary);
    return BaseAction;
}(Action));
exports.BaseAction = BaseAction;
var ContractAction = /** @class */ (function (_super) {
    __extends(ContractAction, _super);
    function ContractAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Contract, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Contract, priority, data) || this;
        }
        return _this;
    }
    ContractAction.GetAll = function () {
        return [this.AdjustDates, this.Allocate, this.ViewContract, this.Lock, this.Rename, this.AddContractLine, this.SwitchType, this.TerminateRolling, this.AdjustUnits, this.Delete, this.AdjustRoles, this.AddProvisionalLine, this.SetContractualEndDate, this.TrimUnAssignedUnits, this.HoldContract, this.UnHoldContract, this.Cancel, this.AddAccountManagementProject, this.AddOutcome];
    };
    ContractAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    ContractAction.AdjustDates = new ContractAction(BaseAction.AdjustDates);
    ContractAction.AdjustUnits = new ContractAction(BaseAction.AdjustUnits);
    ContractAction.Allocate = new ContractAction(null, "Allocate", "Allocate", ety.ActionPriority.Secondary);
    ContractAction.ViewContract = new ContractAction(null, "View Contract", "ViewContract", ety.ActionPriority.Primary);
    ContractAction.Lock = new ContractAction(null, "Lock", "Lock", ety.ActionPriority.Secondary);
    ContractAction.Rename = new ContractAction(null, "Rename", "Rename", ety.ActionPriority.Secondary);
    ContractAction.Delete = new ContractAction(BaseAction.Delete);
    ContractAction.AddContractLine = new ContractAction(null, "Add Contract Line", "AddContractLine", ety.ActionPriority.Primary);
    ContractAction.AddAccountManagementProject = new ContractAction(null, "Add AM Project", "AddAccountManagementProject", ety.ActionPriority.Primary);
    ContractAction.AddProvisionalLine = new ContractAction(null, "Add Provisional Line", "AddProvisionalLine", ety.ActionPriority.Primary);
    ContractAction.SwitchType = new ContractAction(null, "Switch Type", "SwitchType", ety.ActionPriority.Secondary);
    ContractAction.TerminateRolling = new ContractAction(null, "Terminate Rolling", "TerminateRolling", ety.ActionPriority.Secondary);
    ContractAction.AdjustRoles = new ContractAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    ContractAction.SetContractualEndDate = new ContractAction(null, "Set Contractual End", "SetContractualEnd", ety.ActionPriority.Secondary);
    ContractAction.TrimUnAssignedUnits = new ContractAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    ContractAction.HoldContract = new ContractAction(null, "Hold Contract", "HoldContract", ety.ActionPriority.Secondary);
    ContractAction.UnHoldContract = new ContractAction(null, "Un-Hold Contract", "UnHoldContract", ety.ActionPriority.Secondary);
    ContractAction.Cancel = new ContractAction(null, "Conclude Contract", "CancelContract", ety.ActionPriority.Secondary);
    ContractAction.AddOutcome = new ContractAction(null, "Add Outcome", "AddOutcome", ety.ActionPriority.Secondary);
    return ContractAction;
}(BaseAction));
exports.ContractAction = ContractAction;
var OrganizationAction = /** @class */ (function (_super) {
    __extends(OrganizationAction, _super);
    function OrganizationAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Organization, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Organization, priority, data) || this;
        }
        return _this;
    }
    OrganizationAction.GetAll = function () {
        return [this.AddOutcome, this.AddAccountManagementProject, this.AddContract, this.AdjustRoles, this.Delete, this.Rename, this.SwitchType, this.SwitchType, this.Trim];
    };
    OrganizationAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    OrganizationAction.AddOutcome = new OrganizationAction(null, "Add Outcome", "AddOutcome", ety.ActionPriority.Secondary);
    OrganizationAction.AddAccountManagementProject = new OrganizationAction(null, "Add AM Project", "AddAccountManagementProject", ety.ActionPriority.Primary);
    OrganizationAction.AddContract = new OrganizationAction(null, "Add Contract", "AddContract", ety.ActionPriority.Primary);
    OrganizationAction.AdjustRoles = new OrganizationAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    OrganizationAction.Delete = new OrganizationAction(null, "Delete", "Delete", ety.ActionPriority.Secondary);
    OrganizationAction.Rename = new OrganizationAction(null, "Rename", "Rename", ety.ActionPriority.Secondary);
    OrganizationAction.SwitchType = new OrganizationAction(null, "Switch Type", "SwitchType", ety.ActionPriority.Secondary);
    OrganizationAction.Trim = new OrganizationAction(null, "Trim", "Trim", ety.ActionPriority.Secondary);
    return OrganizationAction;
}(BaseAction));
exports.OrganizationAction = OrganizationAction;
var VideoAction = /** @class */ (function (_super) {
    __extends(VideoAction, _super);
    function VideoAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Video, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Video, priority, data) || this;
        }
        return _this;
    }
    VideoAction.GetAll = function () {
        return [this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.CreateFull, this.CreatePartial, this.Start,
            this.Complete, this.ResetPhase, this.Lock, this.Update, this.Delete, this.AcceptApprovalPhase, this.RejectApprovalPhase,
            this.AdjustWorkSlot, this.AddCustomWork, this.RemovePhase, this.AdjustUnits, this.AdjustPhaseUnits, this.Restart, this.Poke,
            this.Provisional, this.SwitchProduct, this.RemovePending, this.AdjustPhaseDates, this.TerminateRollingLine,
            this.Cancel, this.FastForward, this.AdjustRoles, this.AdjustLineRoles, this.HoldProject, this.UnHoldProject, this.CreateMulti,
            this.ForceComplete, this.ConfirmProvisionalLine, this.RenamePhase, this.ToBeScheduled, this.ConfirmSchedule, this.RejectRevision,
            this.TransferContractLine, this.TrimUnAssignedUnits, this.BumpDates, this.RequestDateChange, this.AddPublishProduct];
    };
    VideoAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    VideoAction.AddMessage = new VideoAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    VideoAction.BumpDates = new VideoAction(null, "Bump Dates", "BumpDates", ety.ActionPriority.Primary);
    VideoAction.AdjustDates = new VideoAction(BaseAction.AdjustDates);
    VideoAction.AdjustPhaseDates = new VideoAction(null, "Adjust Phase Dates", "AdjustPhaseDates", ety.ActionPriority.Secondary);
    VideoAction.AdjustUnits = new VideoAction(BaseAction.AdjustUnits);
    VideoAction.AdjustPhaseUnits = new VideoAction(null, "Adjust Phase Units", "AdjustPhaseUnits", ety.ActionPriority.Secondary);
    VideoAction.Allocate = new VideoAction(BaseAction.Allocate);
    VideoAction.ViewProject = new VideoAction(null, "View Project", "ViewProject", ety.ActionPriority.Secondary);
    VideoAction.ViewWork = new VideoAction(null, "View Work", "ViewWork", ety.ActionPriority.Secondary);
    VideoAction.CreateFull = new VideoAction(null, "Create Project", "CreateFullProject", ety.ActionPriority.Primary);
    VideoAction.CreatePartial = new VideoAction(null, "Create Project", "CreatePartialProject", ety.ActionPriority.Primary);
    VideoAction.CreateMulti = new VideoAction(null, "Create Multi", "CreateMultiProject", ety.ActionPriority.Primary);
    VideoAction.Start = new VideoAction(BaseAction.Start);
    VideoAction.Complete = new VideoAction(BaseAction.Complete);
    VideoAction.ResetPhase = new VideoAction(null, "Reset Phase", "ResetPhase", ety.ActionPriority.Secondary);
    VideoAction.Lock = new VideoAction(BaseAction.Lock);
    VideoAction.Rename = new VideoAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    VideoAction.Cancel = new VideoAction(null, "Cancel Project", "CancelProject", ety.ActionPriority.Secondary);
    VideoAction.Delete = new VideoAction(BaseAction.Delete);
    VideoAction.FastForward = new VideoAction(null, "Fast Forward", "FastForward", ety.ActionPriority.Secondary);
    VideoAction.ForceComplete = new VideoAction(null, "Force Complete", "ForceComplete", ety.ActionPriority.Secondary);
    VideoAction.AcceptApprovalPhase = new VideoAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    VideoAction.RejectApprovalPhase = new VideoAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    VideoAction.AdjustWorkSlot = new VideoAction(null, "Adjust Work Slot", "AdjustWorkSlot", ety.ActionPriority.Secondary);
    VideoAction.AddCustomWork = new VideoAction(null, "Add Custom Work", "AddCustomWork", ety.ActionPriority.Primary);
    VideoAction.RemovePhase = new VideoAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    VideoAction.Restart = new VideoAction(null, "Restart Deliverable", "Restart", ety.ActionPriority.Secondary);
    VideoAction.Poke = new VideoAction(null, "Poke", "Poke", ety.ActionPriority.Secondary);
    VideoAction.Provisional = new VideoAction(null, "Provisional", "Provisional", ety.ActionPriority.Secondary);
    VideoAction.SwitchProduct = new VideoAction(null, "Switch Product", "SwitchProduct", ety.ActionPriority.Secondary);
    VideoAction.RemovePending = new VideoAction(null, "Remove Pending", "RemovePending", ety.ActionPriority.Secondary);
    VideoAction.TerminateRollingLine = new VideoAction(null, "Terminate Rolling Line", "TerminateRollingLine", ety.ActionPriority.Secondary);
    VideoAction.AdjustRoles = new VideoAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    VideoAction.AdjustLineRoles = new VideoAction(null, "Adjust Line Roles", "AdjustLineRoles", ety.ActionPriority.Secondary);
    VideoAction.HoldProject = new VideoAction(null, "Hold Project", "HoldProject", ety.ActionPriority.Secondary);
    VideoAction.UnHoldProject = new VideoAction(null, "Un-Hold Project", "UnHoldProject", ety.ActionPriority.Secondary);
    VideoAction.ConfirmProvisionalLine = new VideoAction(null, "Confirm Provisional Line", "ConfirmProvisionalLine", ety.ActionPriority.Primary);
    VideoAction.RenamePhase = new VideoAction(null, "Rename Phase", "RenamePhase", ety.ActionPriority.Secondary);
    VideoAction.ToBeScheduled = new VideoAction(null, "To Be Scheduled", "ToBeScheduled", ety.ActionPriority.Secondary);
    VideoAction.ConfirmSchedule = new VideoAction(null, "Confirm Schedule", "ConfirmSchedule", ety.ActionPriority.Primary);
    VideoAction.RejectRevision = new VideoAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    VideoAction.RequestDateChange = new VideoAction(null, "Request Date Change", "RequestDateChange", ety.ActionPriority.Secondary);
    VideoAction.TransferContractLine = new VideoAction(null, "Transfer ContractLine", "TransferContractLine", ety.ActionPriority.Secondary);
    VideoAction.TrimUnAssignedUnits = new VideoAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    VideoAction.AddPublishProduct = new VideoAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    return VideoAction;
}(BaseAction));
exports.VideoAction = VideoAction;
var DesignAction = /** @class */ (function (_super) {
    __extends(DesignAction, _super);
    function DesignAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Design, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Design, priority, data) || this;
        }
        return _this;
    }
    DesignAction.GetAll = function () {
        return [this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.CreateFull, this.CreatePartial, this.Start,
            this.Complete, this.ResetPhase, this.Lock, this.Update, this.Delete, this.AcceptApprovalPhase, this.RejectApprovalPhase,
            this.AdjustWorkSlot, this.AddCustomWork, this.RemovePhase, this.AdjustUnits, this.AdjustPhaseUnits, this.Restart, this.Poke,
            this.Provisional, this.SwitchProduct, this.RemovePending, this.AdjustPhaseDates, this.TerminateRollingLine,
            this.Cancel, this.FastForward, this.AdjustRoles, this.AdjustLineRoles, this.HoldProject, this.UnHoldProject, this.CreateMulti,
            this.ForceComplete, this.ConfirmProvisionalLine, this.RenamePhase, this.ToBeScheduled, this.ConfirmSchedule, this.RejectRevision,
            this.TransferContractLine, this.TrimUnAssignedUnits, this.BumpDates, this.RequestDateChange, this.AddPublishProduct];
    };
    DesignAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    DesignAction.AddMessage = new DesignAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    DesignAction.BumpDates = new DesignAction(null, "Bump Dates", "BumpDates", ety.ActionPriority.Primary);
    DesignAction.AdjustDates = new DesignAction(BaseAction.AdjustDates);
    DesignAction.AdjustPhaseDates = new DesignAction(null, "Adjust Phase Dates", "AdjustPhaseDates", ety.ActionPriority.Secondary);
    DesignAction.AdjustUnits = new DesignAction(BaseAction.AdjustUnits);
    DesignAction.AdjustPhaseUnits = new DesignAction(null, "Adjust Phase Units", "AdjustPhaseUnits", ety.ActionPriority.Secondary);
    DesignAction.Allocate = new DesignAction(BaseAction.Allocate);
    DesignAction.ViewProject = new DesignAction(null, "View Project", "ViewProject", ety.ActionPriority.Secondary);
    DesignAction.ViewWork = new DesignAction(null, "View Work", "ViewWork", ety.ActionPriority.Secondary);
    DesignAction.CreateFull = new DesignAction(null, "Create Project", "CreateFullProject", ety.ActionPriority.Primary);
    DesignAction.CreatePartial = new DesignAction(null, "Create Project", "CreatePartialProject", ety.ActionPriority.Primary);
    DesignAction.CreateMulti = new DesignAction(null, "Create Multi", "CreateMultiProject", ety.ActionPriority.Primary);
    DesignAction.Start = new DesignAction(BaseAction.Start);
    DesignAction.Complete = new DesignAction(BaseAction.Complete);
    DesignAction.ResetPhase = new DesignAction(null, "Reset Phase", "ResetPhase", ety.ActionPriority.Secondary);
    DesignAction.Lock = new DesignAction(BaseAction.Lock);
    DesignAction.Rename = new DesignAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    DesignAction.Cancel = new DesignAction(null, "Cancel Project", "CancelProject", ety.ActionPriority.Secondary);
    DesignAction.FastForward = new DesignAction(null, "Fast Forward", "FastForward", ety.ActionPriority.Secondary);
    DesignAction.ForceComplete = new DesignAction(null, "Force Complete", "ForceComplete", ety.ActionPriority.Secondary);
    DesignAction.Delete = new DesignAction(BaseAction.Delete);
    DesignAction.AcceptApprovalPhase = new DesignAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    DesignAction.RejectApprovalPhase = new DesignAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    DesignAction.AdjustWorkSlot = new DesignAction(null, "Adjust Work Slot", "AdjustWorkSlot", ety.ActionPriority.Secondary);
    DesignAction.AddCustomWork = new DesignAction(null, "Add Custom Work", "AddCustomWork", ety.ActionPriority.Primary);
    DesignAction.RemovePhase = new DesignAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    DesignAction.Restart = new DesignAction(null, "Restart Deliverable", "Restart", ety.ActionPriority.Secondary);
    DesignAction.Poke = new DesignAction(null, "Poke", "Poke", ety.ActionPriority.Secondary);
    DesignAction.Provisional = new DesignAction(null, "Provisional", "Provisional", ety.ActionPriority.Secondary);
    DesignAction.SwitchProduct = new DesignAction(null, "Switch Product", "SwitchProduct", ety.ActionPriority.Secondary);
    DesignAction.RemovePending = new DesignAction(null, "Remove Pending", "RemovePending", ety.ActionPriority.Secondary);
    DesignAction.TerminateRollingLine = new DesignAction(null, "Terminate Rolling Line", "TerminateRollingLine", ety.ActionPriority.Secondary);
    DesignAction.AdjustRoles = new DesignAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    DesignAction.AdjustLineRoles = new DesignAction(null, "Adjust Line Roles", "AdjustLineRoles", ety.ActionPriority.Secondary);
    DesignAction.HoldProject = new DesignAction(null, "Hold Project", "HoldProject", ety.ActionPriority.Secondary);
    DesignAction.UnHoldProject = new DesignAction(null, "Un-Hold Project", "UnHoldProject", ety.ActionPriority.Secondary);
    DesignAction.ConfirmProvisionalLine = new DesignAction(null, "ConfirmProvisionalLine", "ConfirmProvisionalLine", ety.ActionPriority.Primary);
    DesignAction.RenamePhase = new DesignAction(null, "Rename Phase", "RenamePhase", ety.ActionPriority.Secondary);
    DesignAction.ToBeScheduled = new DesignAction(null, "To Be Scheduled", "ToBeScheduled", ety.ActionPriority.Secondary);
    DesignAction.ConfirmSchedule = new DesignAction(null, "ConfirmS chedule", "ConfirmSchedule", ety.ActionPriority.Primary);
    DesignAction.RejectRevision = new DesignAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    DesignAction.RequestDateChange = new DesignAction(null, "Request Date Change", "RequestDateChange", ety.ActionPriority.Secondary);
    DesignAction.TransferContractLine = new DesignAction(null, "Transfer ContractLine", "TransferContractLine", ety.ActionPriority.Secondary);
    DesignAction.TrimUnAssignedUnits = new DesignAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    DesignAction.AddPublishProduct = new DesignAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    return DesignAction;
}(BaseAction));
exports.DesignAction = DesignAction;
var EditorialAction = /** @class */ (function (_super) {
    __extends(EditorialAction, _super);
    function EditorialAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Editorial, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Editorial, priority, data) || this;
        }
        return _this;
    }
    EditorialAction.GetAll = function () {
        return [this.AddMessage, this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.CreateFull, this.CreatePartial, this.Start,
            this.Complete, this.ResetPhase, this.Lock, this.Update, this.Delete, this.AcceptApprovalPhase, this.RejectApprovalPhase,
            this.AdjustWorkSlot, this.AddCustomWork, this.RemovePhase, this.AdjustUnits, this.AdjustPhaseUnits, this.Restart, this.Poke,
            this.Provisional, this.SwitchProduct, this.RemovePending, this.AdjustPhaseDates, this.TerminateRollingLine,
            this.Cancel, this.FastForward, this.AdjustRoles, this.AdjustLineRoles, this.HoldProject, this.UnHoldProject, this.CreateMulti,
            this.ForceComplete, this.ConfirmProvisionalLine, this.RenamePhase, this.ToBeScheduled, this.ConfirmSchedule, this.RejectRevision,
            this.TransferContractLine, this.TrimUnAssignedUnits, this.BumpDates, this.RequestDateChange, this.AddPublishProduct];
    };
    EditorialAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    EditorialAction.AddMessage = new EditorialAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    EditorialAction.BumpDates = new EditorialAction(null, "Bump Dates", "BumpDates", ety.ActionPriority.Primary);
    EditorialAction.AdjustDates = new EditorialAction(BaseAction.AdjustDates);
    EditorialAction.AdjustPhaseDates = new EditorialAction(null, "Adjust Phase Dates", "AdjustPhaseDates", ety.ActionPriority.Secondary);
    EditorialAction.AdjustUnits = new EditorialAction(BaseAction.AdjustUnits);
    EditorialAction.AdjustPhaseUnits = new EditorialAction(null, "Adjust Phase Units", "AdjustPhaseUnits", ety.ActionPriority.Secondary);
    EditorialAction.Allocate = new EditorialAction(BaseAction.Allocate);
    EditorialAction.ViewProject = new EditorialAction(null, "View Project", "ViewProject", ety.ActionPriority.Secondary);
    EditorialAction.ViewWork = new EditorialAction(null, "View Work", "ViewWork", ety.ActionPriority.Secondary);
    EditorialAction.CreateFull = new EditorialAction(null, "Create Project", "CreateFullProject", ety.ActionPriority.Primary);
    EditorialAction.CreatePartial = new EditorialAction(null, "Create Project", "CreatePartialProject", ety.ActionPriority.Primary);
    EditorialAction.CreateMulti = new EditorialAction(null, "Create Multi", "CreateMultiProject", ety.ActionPriority.Primary);
    EditorialAction.Start = new EditorialAction(BaseAction.Start);
    EditorialAction.Complete = new EditorialAction(BaseAction.Complete);
    EditorialAction.ResetPhase = new EditorialAction(null, "Reset Phase", "ResetPhase", ety.ActionPriority.Secondary);
    EditorialAction.Lock = new EditorialAction(BaseAction.Lock);
    EditorialAction.Rename = new EditorialAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    EditorialAction.Cancel = new EditorialAction(null, "Cancel Project", "CancelProject", ety.ActionPriority.Secondary);
    EditorialAction.FastForward = new EditorialAction(null, "Fast Forward", "FastForward", ety.ActionPriority.Secondary);
    EditorialAction.ForceComplete = new EditorialAction(null, "Force Complete", "ForceComplete", ety.ActionPriority.Secondary);
    EditorialAction.Delete = new EditorialAction(BaseAction.Delete);
    EditorialAction.AcceptApprovalPhase = new EditorialAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    EditorialAction.RejectApprovalPhase = new EditorialAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    EditorialAction.AdjustWorkSlot = new EditorialAction(null, "Adjust Work Slot", "AdjustWorkSlot", ety.ActionPriority.Secondary);
    EditorialAction.AddCustomWork = new EditorialAction(null, "Add Custom Work", "AddCustomWork", ety.ActionPriority.Primary);
    EditorialAction.RemovePhase = new EditorialAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    EditorialAction.Restart = new EditorialAction(null, "Restart Deliverable", "Restart", ety.ActionPriority.Secondary);
    EditorialAction.Poke = new EditorialAction(null, "Poke", "Poke", ety.ActionPriority.Secondary);
    EditorialAction.Provisional = new EditorialAction(null, "Provisional", "Provisional", ety.ActionPriority.Secondary);
    EditorialAction.SwitchProduct = new EditorialAction(null, "Switch Product", "SwitchProduct", ety.ActionPriority.Secondary);
    EditorialAction.RemovePending = new EditorialAction(null, "Remove Pending", "RemovePending", ety.ActionPriority.Secondary);
    EditorialAction.TerminateRollingLine = new EditorialAction(null, "Terminate Rolling Line", "TerminateRollingLine", ety.ActionPriority.Secondary);
    EditorialAction.AdjustRoles = new EditorialAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    EditorialAction.AdjustLineRoles = new EditorialAction(null, "Adjust Line Roles", "AdjustLineRoles", ety.ActionPriority.Secondary);
    EditorialAction.HoldProject = new EditorialAction(null, "Hold Project", "HoldProject", ety.ActionPriority.Secondary);
    EditorialAction.UnHoldProject = new EditorialAction(null, "Un-Hold Project", "UnHoldProject", ety.ActionPriority.Secondary);
    EditorialAction.ConfirmProvisionalLine = new EditorialAction(null, "ConfirmProvisionalLine", "ConfirmProvisionalLine", ety.ActionPriority.Primary);
    EditorialAction.RenamePhase = new EditorialAction(null, "Rename Phase", "RenamePhase", ety.ActionPriority.Secondary);
    EditorialAction.ToBeScheduled = new EditorialAction(null, "To Be Scheduled", "ToBeScheduled", ety.ActionPriority.Secondary);
    EditorialAction.ConfirmSchedule = new EditorialAction(null, "ConfirmS chedule", "ConfirmSchedule", ety.ActionPriority.Primary);
    EditorialAction.RejectRevision = new EditorialAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    EditorialAction.RequestDateChange = new EditorialAction(null, "Request Date Change", "RequestDateChange", ety.ActionPriority.Secondary);
    EditorialAction.TransferContractLine = new EditorialAction(null, "Transfer ContractLine", "TransferContractLine", ety.ActionPriority.Secondary);
    EditorialAction.TrimUnAssignedUnits = new EditorialAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    EditorialAction.AddPublishProduct = new EditorialAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    return EditorialAction;
}(BaseAction));
exports.EditorialAction = EditorialAction;
var SocialAction = /** @class */ (function (_super) {
    __extends(SocialAction, _super);
    function SocialAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Social, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Social, priority, data) || this;
        }
        return _this;
    }
    SocialAction.GetAll = function () {
        return [this.AddMessage, this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.CreateFull, this.CreatePartial, this.Start,
            this.Complete, this.ResetPhase, this.Lock, this.Update, this.Delete, this.AcceptApprovalPhase, this.RejectApprovalPhase,
            this.AdjustWorkSlot, this.AddCustomWork, this.RemovePhase, this.AdjustUnits, this.AdjustPhaseUnits, this.Restart, this.Poke,
            this.Provisional, this.SwitchProduct, this.RemovePending, this.AdjustPhaseDates, this.TerminateRollingLine,
            this.Cancel, this.FastForward, this.AdjustRoles, this.AdjustLineRoles, this.HoldProject, this.UnHoldProject, this.CreateMulti,
            this.ForceComplete, this.ConfirmProvisionalLine, this.RenamePhase, this.ToBeScheduled, this.ConfirmSchedule, this.RejectRevision,
            this.TransferContractLine, this.TrimUnAssignedUnits, this.BumpDates, this.RequestDateChange, this.AddPublishProduct];
    };
    SocialAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    SocialAction.AddMessage = new SocialAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    SocialAction.BumpDates = new SocialAction(null, "Bump Dates", "BumpDates", ety.ActionPriority.Primary);
    SocialAction.AdjustDates = new SocialAction(BaseAction.AdjustDates);
    SocialAction.AdjustPhaseDates = new SocialAction(null, "Adjust Phase Dates", "AdjustPhaseDates", ety.ActionPriority.Secondary);
    SocialAction.AdjustUnits = new SocialAction(BaseAction.AdjustUnits);
    SocialAction.AdjustPhaseUnits = new SocialAction(null, "Adjust Phase Units", "AdjustPhaseUnits", ety.ActionPriority.Secondary);
    SocialAction.Allocate = new SocialAction(BaseAction.Allocate);
    SocialAction.ViewProject = new SocialAction(null, "View Project", "ViewProject", ety.ActionPriority.Secondary);
    SocialAction.ViewWork = new SocialAction(null, "View Work", "ViewWork", ety.ActionPriority.Secondary);
    SocialAction.CreateFull = new SocialAction(null, "Create Project", "CreateFullProject", ety.ActionPriority.Primary);
    SocialAction.CreatePartial = new SocialAction(null, "Create Project", "CreatePartialProject", ety.ActionPriority.Primary);
    SocialAction.CreateMulti = new SocialAction(null, "Create Multi", "CreateMultiProject", ety.ActionPriority.Primary);
    SocialAction.Start = new SocialAction(BaseAction.Start);
    SocialAction.Complete = new SocialAction(BaseAction.Complete);
    SocialAction.ResetPhase = new SocialAction(null, "Reset Phase", "ResetPhase", ety.ActionPriority.Secondary);
    SocialAction.Lock = new SocialAction(BaseAction.Lock);
    SocialAction.Rename = new SocialAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    SocialAction.Cancel = new SocialAction(null, "Cancel Project", "CancelProject", ety.ActionPriority.Secondary);
    SocialAction.FastForward = new SocialAction(null, "Fast Forward", "FastForward", ety.ActionPriority.Secondary);
    SocialAction.ForceComplete = new SocialAction(null, "Force Complete", "ForceComplete", ety.ActionPriority.Secondary);
    SocialAction.Delete = new SocialAction(BaseAction.Delete);
    SocialAction.AcceptApprovalPhase = new SocialAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    SocialAction.RejectApprovalPhase = new SocialAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    SocialAction.AdjustWorkSlot = new SocialAction(null, "Adjust Work Slot", "AdjustWorkSlot", ety.ActionPriority.Secondary);
    SocialAction.AddCustomWork = new SocialAction(null, "Add Custom Work", "AddCustomWork", ety.ActionPriority.Primary);
    SocialAction.RemovePhase = new SocialAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    SocialAction.Restart = new SocialAction(null, "Restart Deliverable", "Restart", ety.ActionPriority.Secondary);
    SocialAction.Poke = new SocialAction(null, "Poke", "Poke", ety.ActionPriority.Secondary);
    SocialAction.Provisional = new SocialAction(null, "Provisional", "Provisional", ety.ActionPriority.Secondary);
    SocialAction.SwitchProduct = new SocialAction(null, "Switch Product", "SwitchProduct", ety.ActionPriority.Secondary);
    SocialAction.RemovePending = new SocialAction(null, "Remove Pending", "RemovePending", ety.ActionPriority.Secondary);
    SocialAction.TerminateRollingLine = new SocialAction(null, "Terminate Rolling Line", "TerminateRollingLine", ety.ActionPriority.Secondary);
    SocialAction.AdjustRoles = new SocialAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    SocialAction.AdjustLineRoles = new SocialAction(null, "Adjust Line Roles", "AdjustLineRoles", ety.ActionPriority.Secondary);
    SocialAction.HoldProject = new SocialAction(null, "Hold Project", "HoldProject", ety.ActionPriority.Secondary);
    SocialAction.UnHoldProject = new SocialAction(null, "Un-Hold Project", "UnHoldProject", ety.ActionPriority.Secondary);
    SocialAction.ConfirmProvisionalLine = new SocialAction(null, "ConfirmProvisionalLine", "ConfirmProvisionalLine", ety.ActionPriority.Primary);
    SocialAction.RenamePhase = new SocialAction(null, "Rename Phase", "RenamePhase", ety.ActionPriority.Secondary);
    SocialAction.ToBeScheduled = new SocialAction(null, "To Be Scheduled", "ToBeScheduled", ety.ActionPriority.Secondary);
    SocialAction.ConfirmSchedule = new SocialAction(null, "ConfirmS chedule", "ConfirmSchedule", ety.ActionPriority.Primary);
    SocialAction.RejectRevision = new SocialAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    SocialAction.RequestDateChange = new SocialAction(null, "Request Date Change", "RequestDateChange", ety.ActionPriority.Secondary);
    SocialAction.TransferContractLine = new SocialAction(null, "Transfer ContractLine", "TransferContractLine", ety.ActionPriority.Secondary);
    SocialAction.TrimUnAssignedUnits = new SocialAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    SocialAction.AddPublishProduct = new SocialAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    return SocialAction;
}(BaseAction));
exports.SocialAction = SocialAction;
var ConsultingAction = /** @class */ (function (_super) {
    __extends(ConsultingAction, _super);
    function ConsultingAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Consulting, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Consulting, priority, data) || this;
        }
        return _this;
    }
    ConsultingAction.GetAll = function () {
        return [this.AddMessage, this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.CreateFull, this.CreatePartial, this.Start,
            this.Complete, this.ResetPhase, this.Lock, this.Update, this.Delete, this.AcceptApprovalPhase, this.RejectApprovalPhase,
            this.AdjustWorkSlot, this.AddCustomWork, this.RemovePhase, this.AdjustUnits, this.AdjustPhaseUnits, this.Restart, this.Poke,
            this.Provisional, this.SwitchProduct, this.RemovePending, this.AdjustPhaseDates, this.TerminateRollingLine,
            this.Cancel, this.FastForward, this.AdjustRoles, this.AdjustLineRoles, this.HoldProject, this.UnHoldProject, this.CreateMulti,
            this.ForceComplete, this.ConfirmProvisionalLine, this.RenamePhase, this.ToBeScheduled, this.ConfirmSchedule, this.RejectRevision,
            this.TransferContractLine, this.TrimUnAssignedUnits, this.BumpDates, this.RequestDateChange, this.AddPublishProduct];
    };
    ConsultingAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    ConsultingAction.AddMessage = new ConsultingAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    ConsultingAction.BumpDates = new ConsultingAction(null, "Bump Dates", "BumpDates", ety.ActionPriority.Primary);
    ConsultingAction.AdjustDates = new ConsultingAction(BaseAction.AdjustDates);
    ConsultingAction.AdjustPhaseDates = new ConsultingAction(null, "Adjust Phase Dates", "AdjustPhaseDates", ety.ActionPriority.Secondary);
    ConsultingAction.AdjustUnits = new ConsultingAction(BaseAction.AdjustUnits);
    ConsultingAction.AdjustPhaseUnits = new ConsultingAction(null, "Adjust Phase Units", "AdjustPhaseUnits", ety.ActionPriority.Secondary);
    ConsultingAction.Allocate = new ConsultingAction(BaseAction.Allocate);
    ConsultingAction.ViewProject = new ConsultingAction(null, "View Project", "ViewProject", ety.ActionPriority.Secondary);
    ConsultingAction.ViewWork = new ConsultingAction(null, "View Work", "ViewWork", ety.ActionPriority.Secondary);
    ConsultingAction.CreateFull = new ConsultingAction(null, "Create Project", "CreateFullProject", ety.ActionPriority.Primary);
    ConsultingAction.CreatePartial = new ConsultingAction(null, "Create Project", "CreatePartialProject", ety.ActionPriority.Primary);
    ConsultingAction.CreateMulti = new ConsultingAction(null, "Create Multi", "CreateMultiProject", ety.ActionPriority.Primary);
    ConsultingAction.Start = new ConsultingAction(BaseAction.Start);
    ConsultingAction.Complete = new ConsultingAction(BaseAction.Complete);
    ConsultingAction.ResetPhase = new ConsultingAction(null, "Reset Phase", "ResetPhase", ety.ActionPriority.Secondary);
    ConsultingAction.Lock = new ConsultingAction(BaseAction.Lock);
    ConsultingAction.Rename = new ConsultingAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    ConsultingAction.Cancel = new ConsultingAction(null, "Cancel Project", "CancelProject", ety.ActionPriority.Secondary);
    ConsultingAction.FastForward = new ConsultingAction(null, "Fast Forward", "FastForward", ety.ActionPriority.Secondary);
    ConsultingAction.ForceComplete = new ConsultingAction(null, "Force Complete", "ForceComplete", ety.ActionPriority.Secondary);
    ConsultingAction.Delete = new ConsultingAction(BaseAction.Delete);
    ConsultingAction.AcceptApprovalPhase = new ConsultingAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    ConsultingAction.RejectApprovalPhase = new ConsultingAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    ConsultingAction.AdjustWorkSlot = new ConsultingAction(null, "Adjust Work Slot", "AdjustWorkSlot", ety.ActionPriority.Secondary);
    ConsultingAction.AddCustomWork = new ConsultingAction(null, "Add Custom Work", "AddCustomWork", ety.ActionPriority.Primary);
    ConsultingAction.RemovePhase = new ConsultingAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    ConsultingAction.Restart = new ConsultingAction(null, "Restart Deliverable", "Restart", ety.ActionPriority.Secondary);
    ConsultingAction.Poke = new ConsultingAction(null, "Poke", "Poke", ety.ActionPriority.Secondary);
    ConsultingAction.Provisional = new ConsultingAction(null, "Provisional", "Provisional", ety.ActionPriority.Secondary);
    ConsultingAction.SwitchProduct = new ConsultingAction(null, "Switch Product", "SwitchProduct", ety.ActionPriority.Secondary);
    ConsultingAction.RemovePending = new ConsultingAction(null, "Remove Pending", "RemovePending", ety.ActionPriority.Secondary);
    ConsultingAction.TerminateRollingLine = new ConsultingAction(null, "Terminate Rolling Line", "TerminateRollingLine", ety.ActionPriority.Secondary);
    ConsultingAction.AdjustRoles = new ConsultingAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    ConsultingAction.AdjustLineRoles = new ConsultingAction(null, "Adjust Line Roles", "AdjustLineRoles", ety.ActionPriority.Secondary);
    ConsultingAction.HoldProject = new ConsultingAction(null, "Hold Project", "HoldProject", ety.ActionPriority.Secondary);
    ConsultingAction.UnHoldProject = new ConsultingAction(null, "Un-Hold Project", "UnHoldProject", ety.ActionPriority.Secondary);
    ConsultingAction.ConfirmProvisionalLine = new ConsultingAction(null, "ConfirmProvisionalLine", "ConfirmProvisionalLine", ety.ActionPriority.Primary);
    ConsultingAction.RenamePhase = new ConsultingAction(null, "Rename Phase", "RenamePhase", ety.ActionPriority.Secondary);
    ConsultingAction.ToBeScheduled = new ConsultingAction(null, "To Be Scheduled", "ToBeScheduled", ety.ActionPriority.Secondary);
    ConsultingAction.ConfirmSchedule = new ConsultingAction(null, "ConfirmS chedule", "ConfirmSchedule", ety.ActionPriority.Primary);
    ConsultingAction.RejectRevision = new ConsultingAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    ConsultingAction.RequestDateChange = new ConsultingAction(null, "Request Date Change", "RequestDateChange", ety.ActionPriority.Secondary);
    ConsultingAction.TransferContractLine = new ConsultingAction(null, "Transfer ContractLine", "TransferContractLine", ety.ActionPriority.Secondary);
    ConsultingAction.TrimUnAssignedUnits = new ConsultingAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    ConsultingAction.AddPublishProduct = new ConsultingAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    return ConsultingAction;
}(BaseAction));
exports.ConsultingAction = ConsultingAction;
var TechAction = /** @class */ (function (_super) {
    __extends(TechAction, _super);
    function TechAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Tech, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Tech, priority, data) || this;
        }
        return _this;
    }
    TechAction.GetAll = function () {
        return [this.AddMessage, this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.CreateFull, this.CreatePartial, this.Start,
            this.Complete, this.ResetPhase, this.Lock, this.Update, this.Delete, this.AcceptApprovalPhase, this.RejectApprovalPhase,
            this.AdjustWorkSlot, this.AddCustomWork, this.RemovePhase, this.AdjustUnits, this.AdjustPhaseUnits, this.Restart, this.Poke,
            this.Provisional, this.SwitchProduct, this.RemovePending, this.AdjustPhaseDates, this.TerminateRollingLine,
            this.Cancel, this.FastForward, this.AdjustRoles, this.AdjustLineRoles, this.HoldProject, this.UnHoldProject, this.CreateMulti,
            this.ForceComplete, this.ConfirmProvisionalLine, this.RenamePhase, this.ToBeScheduled, this.ConfirmSchedule, this.RejectRevision,
            this.TransferContractLine, this.TrimUnAssignedUnits, this.BumpDates, this.RequestDateChange, this.AddPublishProduct];
    };
    TechAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    TechAction.AddMessage = new TechAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    TechAction.BumpDates = new TechAction(null, "Bump Dates", "BumpDates", ety.ActionPriority.Primary);
    TechAction.AdjustDates = new TechAction(BaseAction.AdjustDates);
    TechAction.AdjustPhaseDates = new TechAction(null, "Adjust Phase Dates", "AdjustPhaseDates", ety.ActionPriority.Secondary);
    TechAction.AdjustUnits = new TechAction(BaseAction.AdjustUnits);
    TechAction.AdjustPhaseUnits = new TechAction(null, "Adjust Phase Units", "AdjustPhaseUnits", ety.ActionPriority.Secondary);
    TechAction.Allocate = new TechAction(BaseAction.Allocate);
    TechAction.ViewProject = new TechAction(null, "View Project", "ViewProject", ety.ActionPriority.Secondary);
    TechAction.ViewWork = new TechAction(null, "View Work", "ViewWork", ety.ActionPriority.Secondary);
    TechAction.CreateFull = new TechAction(null, "Create Project", "CreateFullProject", ety.ActionPriority.Primary);
    TechAction.CreatePartial = new TechAction(null, "Create Project", "CreatePartialProject", ety.ActionPriority.Primary);
    TechAction.CreateMulti = new TechAction(null, "Create Multi", "CreateMultiProject", ety.ActionPriority.Primary);
    TechAction.Start = new TechAction(BaseAction.Start);
    TechAction.Complete = new TechAction(BaseAction.Complete);
    TechAction.ResetPhase = new TechAction(null, "Reset Phase", "ResetPhase", ety.ActionPriority.Secondary);
    TechAction.Lock = new TechAction(BaseAction.Lock);
    TechAction.Rename = new TechAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    TechAction.Cancel = new TechAction(null, "Cancel Project", "CancelProject", ety.ActionPriority.Secondary);
    TechAction.FastForward = new TechAction(null, "Fast Forward", "FastForward", ety.ActionPriority.Secondary);
    TechAction.ForceComplete = new TechAction(null, "Force Complete", "ForceComplete", ety.ActionPriority.Secondary);
    TechAction.Delete = new TechAction(BaseAction.Delete);
    TechAction.AcceptApprovalPhase = new TechAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    TechAction.RejectApprovalPhase = new TechAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    TechAction.AdjustWorkSlot = new TechAction(null, "Adjust Work Slot", "AdjustWorkSlot", ety.ActionPriority.Secondary);
    TechAction.AddCustomWork = new TechAction(null, "Add Custom Work", "AddCustomWork", ety.ActionPriority.Primary);
    TechAction.RemovePhase = new TechAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    TechAction.Restart = new TechAction(null, "Restart Deliverable", "Restart", ety.ActionPriority.Secondary);
    TechAction.Poke = new TechAction(null, "Poke", "Poke", ety.ActionPriority.Secondary);
    TechAction.Provisional = new TechAction(null, "Provisional", "Provisional", ety.ActionPriority.Secondary);
    TechAction.SwitchProduct = new TechAction(null, "Switch Product", "SwitchProduct", ety.ActionPriority.Secondary);
    TechAction.RemovePending = new TechAction(null, "Remove Pending", "RemovePending", ety.ActionPriority.Secondary);
    TechAction.TerminateRollingLine = new TechAction(null, "Terminate Rolling Line", "TerminateRollingLine", ety.ActionPriority.Secondary);
    TechAction.AdjustRoles = new TechAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    TechAction.AdjustLineRoles = new TechAction(null, "Adjust Line Roles", "AdjustLineRoles", ety.ActionPriority.Secondary);
    TechAction.HoldProject = new TechAction(null, "Hold Project", "HoldProject", ety.ActionPriority.Secondary);
    TechAction.UnHoldProject = new TechAction(null, "Un-Hold Project", "UnHoldProject", ety.ActionPriority.Secondary);
    TechAction.ConfirmProvisionalLine = new TechAction(null, "ConfirmProvisionalLine", "ConfirmProvisionalLine", ety.ActionPriority.Primary);
    TechAction.RenamePhase = new TechAction(null, "Rename Phase", "RenamePhase", ety.ActionPriority.Secondary);
    TechAction.ToBeScheduled = new TechAction(null, "To Be Scheduled", "ToBeScheduled", ety.ActionPriority.Secondary);
    TechAction.ConfirmSchedule = new TechAction(null, "ConfirmS chedule", "ConfirmSchedule", ety.ActionPriority.Primary);
    TechAction.RejectRevision = new TechAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    TechAction.RequestDateChange = new TechAction(null, "Request Date Change", "RequestDateChange", ety.ActionPriority.Secondary);
    TechAction.TransferContractLine = new TechAction(null, "Transfer ContractLine", "TransferContractLine", ety.ActionPriority.Secondary);
    TechAction.TrimUnAssignedUnits = new TechAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    TechAction.AddPublishProduct = new TechAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    return TechAction;
}(BaseAction));
exports.TechAction = TechAction;
var AccountManagementAction = /** @class */ (function (_super) {
    __extends(AccountManagementAction, _super);
    function AccountManagementAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.AccountManagement, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.AccountManagement, priority, data) || this;
        }
        return _this;
    }
    AccountManagementAction.GetAll = function () {
        return [this.AddMessage, this.AdjustDates, this.Allocate, this.ViewProject, this.ViewWork, this.CreateFull, this.CreatePartial, this.Start,
            this.Complete, this.ResetPhase, this.Lock, this.Update, this.Delete, this.AcceptApprovalPhase, this.RejectApprovalPhase,
            this.AdjustWorkSlot, this.AddCustomWork, this.RemovePhase, this.AdjustUnits, this.AdjustPhaseUnits, this.Restart, this.Poke,
            this.Provisional, this.SwitchProduct, this.RemovePending, this.AdjustPhaseDates, this.TerminateRollingLine,
            this.Cancel, this.FastForward, this.AdjustRoles, this.AdjustLineRoles, this.HoldProject, this.UnHoldProject, this.CreateMulti,
            this.ForceComplete, this.ConfirmProvisionalLine, this.RenamePhase, this.ToBeScheduled, this.ConfirmSchedule, this.RejectRevision,
            this.TransferContractLine, this.TrimUnAssignedUnits, this.BumpDates, this.RequestDateChange];
    };
    AccountManagementAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    AccountManagementAction.AddMessage = new AccountManagementAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    AccountManagementAction.BumpDates = new AccountManagementAction(null, "Bump Dates", "BumpDates", ety.ActionPriority.Primary);
    AccountManagementAction.AdjustDates = new AccountManagementAction(BaseAction.AdjustDates);
    AccountManagementAction.AdjustPhaseDates = new AccountManagementAction(null, "Adjust Phase Dates", "AdjustPhaseDates", ety.ActionPriority.Secondary);
    AccountManagementAction.AdjustUnits = new AccountManagementAction(BaseAction.AdjustUnits);
    AccountManagementAction.AdjustPhaseUnits = new AccountManagementAction(null, "Adjust Phase Units", "AdjustPhaseUnits", ety.ActionPriority.Secondary);
    AccountManagementAction.Allocate = new AccountManagementAction(BaseAction.Allocate);
    AccountManagementAction.ViewProject = new AccountManagementAction(null, "View Project", "ViewProject", ety.ActionPriority.Secondary);
    AccountManagementAction.ViewWork = new AccountManagementAction(null, "View Work", "ViewWork", ety.ActionPriority.Secondary);
    AccountManagementAction.CreateFull = new AccountManagementAction(null, "Create Project", "CreateFullProject", ety.ActionPriority.Primary);
    AccountManagementAction.CreatePartial = new AccountManagementAction(null, "Create Project", "CreatePartialProject", ety.ActionPriority.Primary);
    AccountManagementAction.CreateMulti = new AccountManagementAction(null, "Create Multi", "CreateMultiProject", ety.ActionPriority.Primary);
    AccountManagementAction.Start = new AccountManagementAction(BaseAction.Start);
    AccountManagementAction.Complete = new AccountManagementAction(BaseAction.Complete);
    AccountManagementAction.ResetPhase = new AccountManagementAction(null, "Reset Phase", "ResetPhase", ety.ActionPriority.Secondary);
    AccountManagementAction.Lock = new AccountManagementAction(BaseAction.Lock);
    AccountManagementAction.Rename = new AccountManagementAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    AccountManagementAction.Cancel = new AccountManagementAction(null, "Cancel Project", "CancelProject", ety.ActionPriority.Secondary);
    AccountManagementAction.FastForward = new AccountManagementAction(null, "Fast Forward", "FastForward", ety.ActionPriority.Secondary);
    AccountManagementAction.ForceComplete = new AccountManagementAction(null, "Force Complete", "ForceComplete", ety.ActionPriority.Secondary);
    AccountManagementAction.Delete = new AccountManagementAction(BaseAction.Delete);
    AccountManagementAction.AcceptApprovalPhase = new AccountManagementAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    AccountManagementAction.RejectApprovalPhase = new AccountManagementAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    AccountManagementAction.AdjustWorkSlot = new AccountManagementAction(null, "Adjust Work Slot", "AdjustWorkSlot", ety.ActionPriority.Secondary);
    AccountManagementAction.AddCustomWork = new AccountManagementAction(null, "Add Custom Work", "AddCustomWork", ety.ActionPriority.Primary);
    AccountManagementAction.RemovePhase = new AccountManagementAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    AccountManagementAction.Restart = new AccountManagementAction(null, "Restart Deliverable", "Restart", ety.ActionPriority.Secondary);
    AccountManagementAction.Poke = new AccountManagementAction(null, "Poke", "Poke", ety.ActionPriority.Secondary);
    AccountManagementAction.Provisional = new AccountManagementAction(null, "Provisional", "Provisional", ety.ActionPriority.Secondary);
    AccountManagementAction.SwitchProduct = new AccountManagementAction(null, "Switch Product", "SwitchProduct", ety.ActionPriority.Secondary);
    AccountManagementAction.RemovePending = new AccountManagementAction(null, "Remove Pending", "RemovePending", ety.ActionPriority.Secondary);
    AccountManagementAction.TerminateRollingLine = new AccountManagementAction(null, "Terminate Rolling Line", "TerminateRollingLine", ety.ActionPriority.Secondary);
    AccountManagementAction.AdjustRoles = new AccountManagementAction(null, "Adjust Roles", "AdjustRoles", ety.ActionPriority.Secondary);
    AccountManagementAction.AdjustLineRoles = new AccountManagementAction(null, "Adjust Line Roles", "AdjustLineRoles", ety.ActionPriority.Secondary);
    AccountManagementAction.HoldProject = new AccountManagementAction(null, "Hold Project", "HoldProject", ety.ActionPriority.Secondary);
    AccountManagementAction.UnHoldProject = new AccountManagementAction(null, "Un-Hold Project", "UnHoldProject", ety.ActionPriority.Secondary);
    AccountManagementAction.ConfirmProvisionalLine = new AccountManagementAction(null, "ConfirmProvisionalLine", "ConfirmProvisionalLine", ety.ActionPriority.Primary);
    AccountManagementAction.RenamePhase = new AccountManagementAction(null, "Rename Phase", "RenamePhase", ety.ActionPriority.Secondary);
    AccountManagementAction.ToBeScheduled = new AccountManagementAction(null, "To Be Scheduled", "ToBeScheduled", ety.ActionPriority.Secondary);
    AccountManagementAction.ConfirmSchedule = new AccountManagementAction(null, "ConfirmS chedule", "ConfirmSchedule", ety.ActionPriority.Primary);
    AccountManagementAction.RejectRevision = new AccountManagementAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    AccountManagementAction.RequestDateChange = new AccountManagementAction(null, "Request Date Change", "RequestDateChange", ety.ActionPriority.Secondary);
    AccountManagementAction.TransferContractLine = new AccountManagementAction(null, "Transfer ContractLine", "TransferContractLine", ety.ActionPriority.Secondary);
    AccountManagementAction.TrimUnAssignedUnits = new AccountManagementAction(null, "Trim UnAssigned Units", "TrimUnAssignedUnits", ety.ActionPriority.Secondary);
    return AccountManagementAction;
}(BaseAction));
exports.AccountManagementAction = AccountManagementAction;
var IdeaAction = /** @class */ (function (_super) {
    __extends(IdeaAction, _super);
    function IdeaAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Idea, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Idea, priority, data) || this;
        }
        return _this;
    }
    IdeaAction.GetAll = function () {
        return [this.AddMessage, this.AcceptApproval, this.AddApproval, this.AddMessage, this.AddOutcome, this.AddCampaignOutcome, this.AddContributor,
            this.AddIdeationStage, this.AddProduction, this.AddIdea, this.AddPublish, this.AddTags, this.AssignTask, this.AmendApproval,
            this.Cancel, this.ChangeDueDate, this.ChangeProductType, this.ChangeOwner, this.ChangeTaskDates, this.CompleteTask, this.CompleteIdea,
            this.Create, this.Delete, this.Hold, this.RejectApproval, this.RemoveApproval, this.Resume, this.Rename, this.RenameStage, this.RenameTask,
            this.RemoveAssetOutcome, this.RemoveCampaignOutcome, this.RemoveContributor, this.RemovePhase, this.RemoveApprovalTask, this.RemoveTags, this.RenameAssetOutcome,
            this.StartTask, this.SwitchDependency];
    };
    IdeaAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    IdeaAction.AcceptApproval = new IdeaAction(null, "Accept Approval", "AcceptApproval", ety.ActionPriority.Primary);
    IdeaAction.AddApproval = new IdeaAction(null, "Add Approval", "AddApproval", ety.ActionPriority.Secondary);
    IdeaAction.AddMessage = new IdeaAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    IdeaAction.AddOutcome = new IdeaAction(null, "Add Asset", "AddOutcome", ety.ActionPriority.Secondary);
    IdeaAction.AddCampaignOutcome = new IdeaAction(null, "Add Campaign", "AddCampaignOutcome", ety.ActionPriority.Secondary);
    IdeaAction.AddContributor = new IdeaAction(null, "Add Contributor", "AddContributor", ety.ActionPriority.Secondary);
    IdeaAction.AddIdeationStage = new IdeaAction(null, "Add Ideation Stage", "AddIdeationStage", ety.ActionPriority.Secondary);
    IdeaAction.AmendApproval = new IdeaAction(null, "Amend Approval", "AmendApproval", ety.ActionPriority.Secondary);
    IdeaAction.AddProduction = new IdeaAction(null, "Add Production", "AddProduction", ety.ActionPriority.Secondary);
    IdeaAction.AddIdea = new IdeaAction(null, "Add Idea", "AddIdea", ety.ActionPriority.Secondary);
    IdeaAction.AddPublish = new IdeaAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    IdeaAction.AddTags = new IdeaAction(null, "Add Tags", "AddTags", ety.ActionPriority.Secondary);
    IdeaAction.AssignTask = new IdeaAction(null, "Assign Task", "AssignTask", ety.ActionPriority.Secondary);
    IdeaAction.Cancel = new IdeaAction(null, "Cancel", "Cancel", ety.ActionPriority.Secondary);
    IdeaAction.ChangeDueDate = new IdeaAction(null, "Change Due Date", "ChangeDueDate", ety.ActionPriority.Secondary);
    IdeaAction.ChangeProductType = new IdeaAction(null, "Change Product Type", "ChangeProductType", ety.ActionPriority.Secondary);
    IdeaAction.ChangeOwner = new IdeaAction(null, "Change Owner", "ChangeOwner", ety.ActionPriority.Secondary);
    IdeaAction.ChangeTaskDates = new IdeaAction(null, "Change Task Dates", "ChangeTaskDates", ety.ActionPriority.Secondary);
    IdeaAction.CompleteIdea = new IdeaAction(null, "Complete Idea", "CompleteIdea", ety.ActionPriority.Secondary);
    IdeaAction.CompleteTask = new IdeaAction(null, "Complete Task", "CompleteTask", ety.ActionPriority.Secondary);
    IdeaAction.Create = new IdeaAction(null, "Create", "Create", ety.ActionPriority.Primary);
    IdeaAction.Delete = new IdeaAction(null, "Delete", "Delete", ety.ActionPriority.Secondary);
    IdeaAction.Hold = new IdeaAction(null, "Hold", "Hold", ety.ActionPriority.Secondary);
    IdeaAction.RequestApproval = new IdeaAction(null, "Request Approval", "RequestApproval", ety.ActionPriority.Primary);
    IdeaAction.RejectApproval = new IdeaAction(null, "Reject Approval", "RejectApproval", ety.ActionPriority.Primary);
    IdeaAction.RemoveApproval = new IdeaAction(null, "Remove Approval", "RemoveApproval", ety.ActionPriority.Primary);
    IdeaAction.Resume = new IdeaAction(null, "Resume", "Resume", ety.ActionPriority.Secondary);
    IdeaAction.Rename = new IdeaAction(null, "Rename", "Rename", ety.ActionPriority.Secondary);
    IdeaAction.RenameStage = new IdeaAction(null, "Rename Stage", "RenameStage", ety.ActionPriority.Secondary);
    IdeaAction.RenameTask = new IdeaAction(null, "Rename Task", "RenameTask", ety.ActionPriority.Secondary);
    IdeaAction.RemoveAssetOutcome = new IdeaAction(null, "Remove Asset Outcome", "RemoveAssetOutcome", ety.ActionPriority.Secondary);
    IdeaAction.RemoveCampaignOutcome = new IdeaAction(null, "Remove Campaign Outcome", "RemoveCampaignOutcome", ety.ActionPriority.Secondary);
    IdeaAction.RemoveContributor = new IdeaAction(null, "Remove Contributor", "RemoveContributor", ety.ActionPriority.Secondary);
    IdeaAction.RemovePhase = new IdeaAction(null, "Remove Phase", "RemovePhase", ety.ActionPriority.Secondary);
    IdeaAction.RemoveApprovalTask = new IdeaAction(null, "Remove Approval Task", "RemoveApprovalTask", ety.ActionPriority.Secondary);
    IdeaAction.RemoveTags = new IdeaAction(null, "Remove Tags", "RemoveTags", ety.ActionPriority.Secondary);
    IdeaAction.RenameAssetOutcome = new IdeaAction(null, "Rename Asset Outcome", "RenameAssetOutcome", ety.ActionPriority.Secondary);
    IdeaAction.StartTask = new IdeaAction(null, "Start Task", "StartTask", ety.ActionPriority.Primary);
    IdeaAction.SwitchDependency = new IdeaAction(null, "Switch Dependency", "SwitchDependency", ety.ActionPriority.Secondary);
    return IdeaAction;
}(BaseAction));
exports.IdeaAction = IdeaAction;
var ProductionAction = /** @class */ (function (_super) {
    __extends(ProductionAction, _super);
    function ProductionAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Production, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Production, priority, data) || this;
        }
        return _this;
    }
    ProductionAction.GetAll = function () {
        return [this.AddMessage, this.AcceptApprovalPhase, this.AddApproval, this.AddMessage, this.AddOutcome, this.AddCampaignOutcome, this.AddContributor,
            this.AddProductionStage, this.AddDependentProductionStage, this.AddProduction, this.AddIdea, this.AddPublish, this.AddTags, this.AssignTask,
            this.Cancel, this.ChangeDates, this.ChangeProductType, this.ChangeOwner, this.ChangeOutcomePhase, this.ChangeTaskDates, this.CompleteTask,
            this.Create, this.Delete, this.Hold, this.RejectApprovalPhase, this.RejectRevision, this.Resume, this.Rename, this.RenameStage, this.RenameTask,
            this.RemoveAssetOutcome, this.RemoveCampaignOutcome, this.RemoveContributor, this.RemoveStage, this.RemoveApprovalTask, this.RemoveTags, this.RenameAssetOutcome,
            this.StartTask, this.SwitchDependency];
    };
    ProductionAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    ProductionAction.AcceptApprovalPhase = new ProductionAction(null, "Accept Approval Phase", "AcceptApprovalPhase", ety.ActionPriority.Primary);
    ProductionAction.AddApproval = new ProductionAction(null, "Add Approval", "AddApproval", ety.ActionPriority.Secondary);
    ProductionAction.AddMessage = new ProductionAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    ProductionAction.AddOutcome = new ProductionAction(null, "Add Asset", "AddOutcome", ety.ActionPriority.Secondary);
    ProductionAction.AddCampaignOutcome = new ProductionAction(null, "Add Campaign", "AddCampaignOutcome", ety.ActionPriority.Secondary);
    ProductionAction.AddContributor = new ProductionAction(null, "Add Contributor", "AddContributor", ety.ActionPriority.Secondary);
    ProductionAction.AddProductionStage = new ProductionAction(null, "Add Production Stage", "AddProductionStage", ety.ActionPriority.Secondary);
    ProductionAction.AddDependentProductionStage = new ProductionAction(null, "Add Dependent Production Stage", "AddDependentProductionStage", ety.ActionPriority.Secondary);
    ProductionAction.AddProduction = new ProductionAction(null, "Add Production", "AddProduction", ety.ActionPriority.Secondary);
    ProductionAction.AddIdea = new ProductionAction(null, "Add Idea", "AddIdea", ety.ActionPriority.Secondary);
    ProductionAction.AddPublish = new ProductionAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    ProductionAction.AddTags = new ProductionAction(null, "Add Tags", "AddTags", ety.ActionPriority.Secondary);
    ProductionAction.AssignTask = new ProductionAction(null, "Assign Task", "AssignTask", ety.ActionPriority.Secondary);
    ProductionAction.Cancel = new ProductionAction(null, "Cancel", "Cancel", ety.ActionPriority.Secondary);
    ProductionAction.ChangeDates = new ProductionAction(null, "Change Dates", "ChangeDates", ety.ActionPriority.Secondary);
    ProductionAction.ChangeProductType = new ProductionAction(null, "Change Product Type", "ChangeProductType", ety.ActionPriority.Secondary);
    ProductionAction.ChangeOwner = new ProductionAction(null, "Change Owner", "ChangeOwner", ety.ActionPriority.Secondary);
    ProductionAction.ChangeOutcomePhase = new ProductionAction(null, "Change Outcome Phase", "ChangeOutcomePhase", ety.ActionPriority.Secondary);
    ProductionAction.ChangeTaskDates = new ProductionAction(null, "Change Task Dates", "ChangeTaskDates", ety.ActionPriority.Secondary);
    ProductionAction.CompleteTask = new ProductionAction(null, "Complete Task", "CompleteTask", ety.ActionPriority.Secondary);
    ProductionAction.Create = new ProductionAction(null, "Create", "Create", ety.ActionPriority.Primary);
    ProductionAction.Delete = new ProductionAction(null, "Delete", "Delete", ety.ActionPriority.Secondary);
    ProductionAction.Hold = new ProductionAction(null, "Hold", "Hold", ety.ActionPriority.Secondary);
    ProductionAction.RejectApprovalPhase = new ProductionAction(null, "Reject Approval Phase", "RejectApprovalPhase", ety.ActionPriority.Primary);
    ProductionAction.RejectRevision = new ProductionAction(null, "Reject Revision", "RejectRevision", ety.ActionPriority.Primary);
    ProductionAction.Resume = new ProductionAction(null, "Resume", "Resume", ety.ActionPriority.Secondary);
    ProductionAction.Rename = new ProductionAction(null, "Rename", "Rename", ety.ActionPriority.Secondary);
    ProductionAction.RenameStage = new ProductionAction(null, "Rename Stage", "RenameStage", ety.ActionPriority.Secondary);
    ProductionAction.RenameTask = new ProductionAction(null, "Rename Task", "RenameTask", ety.ActionPriority.Secondary);
    ProductionAction.RemoveAssetOutcome = new ProductionAction(null, "Remove Asset Outcome", "RemoveAssetOutcome", ety.ActionPriority.Secondary);
    ProductionAction.RemoveCampaignOutcome = new ProductionAction(null, "Remove Campaign Outcome", "RemoveCampaignOutcome", ety.ActionPriority.Secondary);
    ProductionAction.RemoveContributor = new ProductionAction(null, "Remove Contributor", "RemoveContributor", ety.ActionPriority.Secondary);
    ProductionAction.RemoveStage = new ProductionAction(null, "Remove Stage", "RemoveStage", ety.ActionPriority.Secondary);
    ProductionAction.RemoveApprovalTask = new ProductionAction(null, "Remove Approval Task", "RemoveApprovalTask", ety.ActionPriority.Secondary);
    ProductionAction.RemoveTags = new ProductionAction(null, "Remove Tags", "RemoveTags", ety.ActionPriority.Secondary);
    ProductionAction.RenameAssetOutcome = new ProductionAction(null, "Rename Asset Outcome", "RenameAssetOutcome", ety.ActionPriority.Secondary);
    ProductionAction.StartTask = new ProductionAction(null, "Start Task", "StartTask", ety.ActionPriority.Primary);
    ProductionAction.SwitchDependency = new ProductionAction(null, "Switch Dependency", "SwitchDependency", ety.ActionPriority.Secondary);
    return ProductionAction;
}(BaseAction));
exports.ProductionAction = ProductionAction;
var PublishAction = /** @class */ (function (_super) {
    __extends(PublishAction, _super);
    function PublishAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.Publish, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.Publish, priority, data) || this;
        }
        return _this;
    }
    PublishAction.GetAll = function () {
        return [this.AddMessage, this.AcceptApproval, this.AddPublishStage, this.AddProduction, this.AddIdea, this.AddPublish, this.AssignTask, this.ChangeOwner,
            this.ChangeOwner, this.ChangeDates, this.ChangeProductType, this.ChangeTaskDates, this.CompleteTask, this.Delete, this.Import, this.Lock,
            this.PublishContentLibrary, this.PublishLocationUpdate, this.PublishSimple, this.RePublishContentLibrary, this.RejectApproval, this.RemoveStage,
            this.ResetTask, this.Rename, this.RemoveTask, this.Resume, this.StartTask, this.SwitchDependency];
    };
    PublishAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    PublishAction.AcceptApproval = new PublishAction(null, "Accept Approval", "AcceptApproval", ety.ActionPriority.Primary);
    PublishAction.AddMessage = new PublishAction(null, "Send Message", "AddMessage", ety.ActionPriority.Secondary);
    PublishAction.AddPublishStage = new PublishAction(null, "Add Publish Stage", "AddPublishStage", ety.ActionPriority.Secondary);
    PublishAction.AddProduction = new PublishAction(null, "Add Production", "AddProduction", ety.ActionPriority.Secondary);
    PublishAction.AddIdea = new PublishAction(null, "Add Idea", "AddIdea", ety.ActionPriority.Secondary);
    PublishAction.AddPublish = new PublishAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    PublishAction.AssignTask = new PublishAction(null, "Assign Task", "AssignTask", ety.ActionPriority.Secondary);
    PublishAction.ChangeOwner = new PublishAction(null, "Change Owner", "ChangeOwner", ety.ActionPriority.Secondary);
    PublishAction.ChangeDates = new PublishAction(null, "Change Dates", "ChangeDates", ety.ActionPriority.Secondary);
    PublishAction.ChangeProductType = new PublishAction(null, "Change Product Type", "ChangeProductType", ety.ActionPriority.Secondary);
    PublishAction.ChangeTaskDates = new PublishAction(null, "Change Task Dates", "ChangeTaskDates", ety.ActionPriority.Secondary);
    PublishAction.CompleteTask = new PublishAction(null, "Complete Task", "CompleteTask", ety.ActionPriority.Primary);
    PublishAction.Delete = new PublishAction(null, "Delete", "Delete", ety.ActionPriority.Secondary);
    PublishAction.Import = new PublishAction(null, "Import", "Import", ety.ActionPriority.Secondary);
    PublishAction.Lock = new PublishAction(null, "Lock", "Lock", ety.ActionPriority.Secondary);
    PublishAction.PublishContentLibrary = new PublishAction(null, "Publish", "PublishContentLibrary", ety.ActionPriority.Primary);
    PublishAction.PublishLocationUpdate = new PublishAction(null, "Publish Location Update", "PublishLocationUpdate", ety.ActionPriority.Primary);
    PublishAction.PublishSimple = new PublishAction(null, "Publish Simple", "PublishSimple", ety.ActionPriority.Primary);
    PublishAction.RePublishContentLibrary = new PublishAction(null, "RePublish", "RePublishContentLibrary", ety.ActionPriority.Primary);
    PublishAction.RejectApproval = new PublishAction(null, "Reject Approval", "RejectApproval", ety.ActionPriority.Primary);
    PublishAction.RemoveStage = new PublishAction(null, "Remove Stage", "RemoveStage", ety.ActionPriority.Secondary);
    PublishAction.RemoveTask = new PublishAction(null, "Remove Task", "RemoveTask", ety.ActionPriority.Secondary);
    PublishAction.ResetTask = new PublishAction(null, "Reset Task", "ResetTask", ety.ActionPriority.Secondary);
    PublishAction.Rename = new PublishAction(null, "Rename / Edit Notes", "Rename", ety.ActionPriority.Secondary);
    PublishAction.RenameTask = new PublishAction(null, "Rename Task", "RenameTask", ety.ActionPriority.Secondary);
    PublishAction.Resume = new PublishAction(null, "Resume", "Resume", ety.ActionPriority.Secondary);
    PublishAction.StartTask = new PublishAction(null, "Start Task", "StartTask", ety.ActionPriority.Primary);
    PublishAction.SwitchDependency = new PublishAction(null, "Switch Dependency", "SwitchDependency", ety.ActionPriority.Primary);
    return PublishAction;
}(BaseAction));
exports.PublishAction = PublishAction;
var MasterProjectAction = /** @class */ (function (_super) {
    __extends(MasterProjectAction, _super);
    function MasterProjectAction(baseDeliverableAction, name, id, priority, data) {
        var _this = this;
        if (baseDeliverableAction instanceof BaseAction) {
            _this = _super.call(this, baseDeliverableAction.name, baseDeliverableAction.id, ety.DeliverableModule.MasterProject, baseDeliverableAction.priority, data) || this;
        }
        else {
            _this = _super.call(this, name, id, ety.DeliverableModule.MasterProject, priority, data) || this;
        }
        return _this;
    }
    MasterProjectAction.GetAll = function () {
        return [this.AddCampaignOutcome, this.AddContributor, this.AddProduction, this.AddIdea, this.AddPublish, this.AddTags, this.ChangeProductType,
            this.ChangeOwner, this.Create, this.Delete, this.Hold, this.Rename, this.Resume, this.RemoveCampaignOutcome, this.RemoveContributor, this.RemoveTags];
    };
    MasterProjectAction.FromId = function (pid) {
        return this.GetAll().find(function (x) { return x.id == pid; });
    };
    MasterProjectAction.AddCampaignOutcome = new MasterProjectAction(null, "Add Campaign Outcome", "AddCampaignOutcome", ety.ActionPriority.Secondary);
    MasterProjectAction.AddContributor = new MasterProjectAction(null, "Add Contributor", "AddContributor", ety.ActionPriority.Secondary);
    MasterProjectAction.AddIdea = new MasterProjectAction(null, "Add Idea", "AddIdea", ety.ActionPriority.Secondary);
    MasterProjectAction.AddProduction = new MasterProjectAction(null, "Add Production", "AddProduction", ety.ActionPriority.Secondary);
    MasterProjectAction.AddPublish = new MasterProjectAction(null, "Add Publish", "AddPublish", ety.ActionPriority.Secondary);
    MasterProjectAction.AddTags = new MasterProjectAction(null, "Add Tags", "AddTags", ety.ActionPriority.Secondary);
    MasterProjectAction.Cancel = new MasterProjectAction(null, "Cancel", "Cancel", ety.ActionPriority.Secondary);
    MasterProjectAction.ChangeOwner = new MasterProjectAction(null, "Change Owner", "ChangeOwner", ety.ActionPriority.Secondary);
    MasterProjectAction.ChangeProductType = new MasterProjectAction(null, "Change Product Type", "ChangeProductType", ety.ActionPriority.Secondary);
    MasterProjectAction.Create = new MasterProjectAction(null, "Create", "Create", ety.ActionPriority.Secondary);
    MasterProjectAction.Delete = new MasterProjectAction(null, "Delete", "Delete", ety.ActionPriority.Secondary);
    MasterProjectAction.Hold = new MasterProjectAction(null, "Hold", "Hold", ety.ActionPriority.Secondary);
    MasterProjectAction.Rename = new MasterProjectAction(null, "Rename", "Rename", ety.ActionPriority.Secondary);
    MasterProjectAction.Resume = new MasterProjectAction(null, "Resume", "Resume", ety.ActionPriority.Secondary);
    MasterProjectAction.RemoveCampaignOutcome = new MasterProjectAction(null, "Remove Campaign Outcome", "RemoveCampaignOutcome", ety.ActionPriority.Secondary);
    MasterProjectAction.RemoveContributor = new MasterProjectAction(null, "Remove Contributor", "RemoveContributor", ety.ActionPriority.Secondary);
    MasterProjectAction.RemoveTags = new MasterProjectAction(null, "Remove Tags", "RemoveTags", ety.ActionPriority.Secondary);
    return MasterProjectAction;
}(BaseAction));
exports.MasterProjectAction = MasterProjectAction;
